module.exports = __webpack_public_path__ + "m-b-logo-cbe38d33.png";